(function ($) {
  Drupal.behaviors.boutiquesspinner = { // re-triggers document.onload
    attach: function (context, settings) { // re-triggers $(document).ready()
    // Append the spinner.
      $('.boutiques_spinner_v1_target').append(spinner.el);
    }
  };
})(jQuery);
